import React from 'react';
import { Caption } from '@randajan/jet-react/dom/caption';
import { Reveal } from '../../../elements/Reveal/Reveal';

import "./References.scss";

export const References = (props)=>{
    const { content } = props;

    return (
        <article className="References">
            <Reveal as="header">
                <span>Reference</span>
                <Caption>Zkušenosti napříč obory</Caption>
                <p>{content.intro}</p>
            </Reveal>
            <div className="References__customers">
                {content.customers.map(customer=>(
                    <Reveal as="span" key={customer}>{customer}</Reveal>
                ))}
            </div>
            <div className="References__segments">
                {content.segments.map((segment, index)=>(
                    <Reveal as="section" className="References__segment" key={segment.id} delay={index * 60}>
                        <h3>{segment.title}</h3>
                        <p>{segment.customers.join(", ")}</p>
                        <ul>
                            {segment.services.map(service=><li key={service}>{service}</li>)}
                        </ul>
                    </Reveal>
                ))}
            </div>
        </article>
    )
}
